import React from 'react';
import './Triangle.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function Triangle({
  direction,
  className,
  isActive,
  onClick,
  testId,
}) {
  return (
    <div
      className={classNames({
        triangle: true,
        [`triangle--${direction}`]: true,
        [`triangle--${direction}--active`]: isActive,
        [`data-analytics-${className}-${
          direction === 'right' ? 'uncollapse' : 'collapse'
        }`]: true,
      })}
      onClick={onClick}
      data-testid={testId}
    />
  );
}

Triangle.propTypes = {
  direction: PropTypes.oneOf(['up', 'down', 'right', 'left']).isRequired,
  isActive: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  testId: PropTypes.string,
};

Triangle.defaultProps = {
  isActive: false,
  className: '',
  testId: '',
  onClick: event => {
    event.stopPropagation();
  },
};
